const images = [
  // obecna galerie
  // kategorie: newborn, pary, rodina, tehotenske

  // newborn
  // {
  //    url: '/assets/gallery/newborn/newborn (1).webp',
  //    category: 'newborn'
  //},
  {
    url: "/assets/gallery/newborn/newborn (1).webp",
    category: "newborn",
    alt: "Newborn fotografie - jemné portré novorozence",
  },
  {
    url: "/assets/gallery/newborn/newborn (2).webp",
    category: "newborn",
    alt: "Newborn fotografie - novorozeně v košíku",
  },
  {
    url: "/assets/gallery/newborn/newborn (3).webp",
    category: "newborn",
    alt: "Newborn fotografie - detailní záběr novorozence",
  },
  {
    url: "/assets/gallery/newborn/newborn (4).webp",
    category: "newborn",
    alt: "Newborn fotografie - novorozeně v přírodním prostředí",
  },
  {
    url: "/assets/gallery/newborn/newborn (5).webp",
    category: "newborn",
    alt: "Newborn fotografie - intimní moment s novorozencem",
  },

  // pary
  {
    url: "/assets/gallery/pary/pary (1).webp",
    category: "pary",
    alt: "Fotografie párů - romantický portrét milenců",
  },
  {
    url: "/assets/gallery/pary/pary (2).webp",
    category: "pary",
    alt: "Fotografie párů - pár v přírodě",
  },
  {
    url: "/assets/gallery/pary/pary (3).webp",
    category: "pary",
    alt: "Fotografie párů - intimní moment dvojice",
  },

  // rodina
  {
    url: "/assets/gallery/rodina/rodina (1).webp",
    category: "rodina",
    alt: "Rodinná fotografie - portrét rodiny",
  },
  {
    url: "/assets/gallery/rodina/rodina (2).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodina v přírodě",
  },
  {
    url: "/assets/gallery/rodina/rodina (3).webp",
    category: "rodina",
    alt: "Rodinná fotografie - skupinový portrét",
  },
  {
    url: "/assets/gallery/rodina/rodina (4).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinný piknik",
  },
  {
    url: "/assets/gallery/rodina/rodina (5).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinný portrét",
  },
  {
    url: "/assets/gallery/rodina/rodina (6).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodina s dětmi",
  },
  {
    url: "/assets/gallery/rodina/rodina (7).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinný moment",
  },
  {
    url: "/assets/gallery/rodina/rodina (8).webp",
    category: "rodina",
    alt: "Rodinná fotografie - portrét rodičů s dětmi",
  },
  {
    url: "/assets/gallery/rodina/rodina (9).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinná fotografie",
  },
  {
    url: "/assets/gallery/rodina/rodina (10).webp",
    category: "rodina",
    alt: "Rodinná fotografie - skupinový záběr rodiny",
  },
  {
    url: "/assets/gallery/rodina/rodina (11).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodina na procházce",
  },
  {
    url: "/assets/gallery/rodina/rodina (12).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinný portrét",
  },
  {
    url: "/assets/gallery/rodina/rodina (13).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodina v domácím prostředí",
  },
  {
    url: "/assets/gallery/rodina/rodina (14).webp",
    category: "rodina",
    alt: "Rodinná fotografie - skupinový portrét",
  },
  {
    url: "/assets/gallery/rodina/rodina (15).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinná fotografie",
  },
  {
    url: "/assets/gallery/rodina/rodina (16).webp",
    category: "rodina",
    alt: "Rodinná fotografie - portrét rodiny",
  },
  {
    url: "/assets/gallery/rodina/rodina (17).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodina s dětmi",
  },
  {
    url: "/assets/gallery/rodina/rodina (18).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinný moment",
  },
  {
    url: "/assets/gallery/rodina/rodina (19).webp",
    category: "rodina",
    alt: "Rodinná fotografie - skupinový záběr",
  },
  {
    url: "/assets/gallery/rodina/rodina (20).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodina v přírodě",
  },
  {
    url: "/assets/gallery/rodina/rodina (21).webp",
    category: "rodina",
    alt: "Rodinná fotografie - rodinný portrét",
  },
  {
    url: "/assets/gallery/rodina/rodina (22).webp",
    category: "rodina",
    alt: "Rodinná fotografie - skupinový portrét rodiny",
  },

  // tehotenske
  {
    url: "/assets/gallery/tehotenske/tehotenske (1).webp",
    category: "tehotenske",
    alt: "Těhotenská fotografie - portrét těhotné ženy",
  },
  {
    url: "/assets/gallery/tehotenske/tehotenske (2).webp",
    category: "tehotenske",
    alt: "Těhotenská fotografie - těhotná v přírodě",
  },
  {
    url: "/assets/gallery/tehotenske/tehotenske (3).webp",
    category: "tehotenske",
    alt: "Těhotenská fotografie - intimní moment těhotenství",
  },
  {
    url: "/assets/gallery/tehotenske/tehotenske (4).webp",
    category: "tehotenske",
    alt: "Těhotenská fotografie - portrét nastávající matky",
  },
  {
    url: "/assets/gallery/tehotenske/tehotenske (5).webp",
    category: "tehotenske",
    alt: "Těhotenská fotografie - těhotná žena v domácím prostředí",
  },
  {
    url: "/assets/gallery/tehotenske/tehotenske (6).webp",
    category: "tehotenske",
    alt: "Těhotenská fotografie - krásný moment těhotenství",
  },
  {
    url: "/assets/gallery/tehotenske/tehotenske (7).webp",
    category: "tehotenske",
    alt: "Těhotenská fotografie - portrét těhotné ženy",
  },

  // svatebni galerie
  // kategorie: svatby
  {
    url: "/assets/gallery/svatby/svatby (11).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební portrét",
  },
  {
    url: "/assets/gallery/svatby/svatby (12).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební moment",
  },
  {
    url: "/assets/gallery/svatby/svatby (13).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební fotografie",
  },
  {
    url: "/assets/gallery/svatby/svatby (14).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební portrét",
  },
  {
    url: "/assets/gallery/svatby/svatby (15).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební moment",
  },
  {
    url: "/assets/gallery/svatby/svatby (1).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební fotografie",
  },
  {
    url: "/assets/gallery/svatby/svatby (2).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební portrét",
  },
  {
    url: "/assets/gallery/svatby/svatby (3).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební moment",
  },
  {
    url: "/assets/gallery/svatby/svatby (4).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební fotografie",
  },
  {
    url: "/assets/gallery/svatby/svatby (5).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební portrét",
  },
  {
    url: "/assets/gallery/svatby/svatby (6).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební moment",
  },
  {
    url: "/assets/gallery/svatby/svatby (7).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební fotografie",
  },
  {
    url: "/assets/gallery/svatby/svatby (8).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební portrét",
  },
  {
    url: "/assets/gallery/svatby/svatby (9).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební moment",
  },
  {
    url: "/assets/gallery/svatby/svatby (10).webp",
    category: "svatby",
    alt: "Svatební fotografie - svatební fotografie",
  },

  // vanoce

  {
    url: "/assets/gallery/vanoce/vanoce(1).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční atmosféra",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(2).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční portrét",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(3).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční moment",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(4).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - rodinné vánoční focení",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(5).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční atmosféra",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(6).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční portrét",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(7).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční moment",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(8).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - rodinné vánoční focení",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(9).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční atmosféra",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(10).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční portrét",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(11).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční moment",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(12).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - rodinné vánoční focení",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(13).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční atmosféra",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(14).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční portrét",
  },
  {
    url: "/assets/gallery/vanoce/vanoce(15).webp",
    category: "vanoce",
    alt: "Vánoční fotografie - vánoční moment",
  },
];

export default images;
